import React from 'react';
import NotFoundContainer from 'features/NotFound';

const NotFoundPage = () => <NotFoundContainer />;

export default NotFoundPage;
